import { makeGetRequest, makePostRequest } from "../makeRequest";
import appConfig from "../../config/app.config";

export const uploadUserCoupon = async (data) => {
  try {
    const activityData = await makePostRequest(
      appConfig.apiUrl.uploadUserCoupon,
      data
    );
    return activityData.data;
  } catch (error) {
    return error?.response.data || error?.response;
  }
};
